import React from 'react'

import Button from "../Util/Button"

import "./AboutUs.css"

import {useTranslate} from "../Context/LanguageContext"

const AboutUs = () => {
    const t = useTranslate("about")

    return ( 
        <div className='about'>

            <section className='start'>

                <div className='heading'>

                    <div className='logo'>
                        <img src="./images/logo3.svg" alt="" decoding='async' />
                        <p>SINIS</p>
                    </div>

                    <h1> 
                        {t("heading1")} <br/> 
                        {t("heading2")}  <br/>
                        in <span>{t("heading3")} </span> <br/>
                        {t("heading4")}  <span>{t("heading5")} </span> <br/>
                    </h1>

                </div>

                <div className='shape right'>
                    <img className='img' src='./images/about-1.webp' alt='' loading='eager' decoding='async' />
                    <span className='overlay'/>
                </div>
                
            </section>

            <section className='about-intro'>
                <h2>
                    <img src="./images/logo3.svg" alt="" decoding='async' />
                    {t("about")} 
                </h2>

                <p>
                    {t("about-txt")} 
                </p>

                <span className='shape left'/>
            </section>

            <section className='about-info'>

                <img src='./images/about-2.webp' alt='' loading='lazy' decoding='async' />

                <span className='shape right'>
                    <p>
                        {t("text1")} 
                    </p>

                    <p>
                        {t("text2")} 
                    </p>

                    <p>
                        {t("text3")} 
                    </p>
                </span>

            </section>


            <section className='about-end'>
                <div className='logo'>
                    <img src="./images/logo3.svg" alt="" decoding='async' />
                    <p>SINIS</p>
                </div>

                <p>
                    {t("text4")} 
                </p>

                <p>
                    {t("text5")} 
                </p>

                <Button to="/contact" filled>{t("contact")}</Button>

            </section>    

                

        </div>
    );
}
 
export default AboutUs;